import moment from "moment-timezone";

// set timezone for moment to Thailand
moment.tz.setDefault("Asia/Bangkok");

window.moment = moment;

export default moment;

// offset time without caring about the timezone
// Example: "2023-01-01T11:00:00-0300" -> "2023-01-01T21:00:00-0300"
//          "2023-01-01T11:00:00-0300" <- "2023-01-01T21:00:00-0300"
// only for fixing bugs in DatePicker because it doesn't care about the timezone
export const localTimeToPickerTime = date => {
	date = date || new Date();
	const newDate = new Date((date.getTime() + (date.getTimezoneOffset() + 420)*60*1000));
	return newDate;
}
export const pickerTimeTolocalTime = date => {
	date = date || new Date();
	const newDate = new Date((date.getTime() - (date.getTimezoneOffset() + 420)*60*1000));
	return newDate;
}